import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import { setSearchData } from '../../../redux/actions/searchAction';
import { setRepetativeActive } from '../../../redux/actions/reportAction';
import lodash  from 'lodash/array';
import { NavLink } from 'react-router-dom';

class AddressesReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            address : false,
            currentTab: '1',
            reportsCollapsed: true
        }

        this._mapReports = this._mapReports.bind(this);
        this.toggleTab = this.toggleTab.bind(this);
        this.toggleReportCollapse = this.toggleReportCollapse.bind(this);
    }
    componentDidMount() {
        const addressId = this.props.match.params.id;
        let address = this.props.addresses.find( address => address.dp_address_id === addressId );

        this.setState({
            ...this.state,
            address: address
        })
    }

    _getTwoDigits(int) {
        return int + (int < 10? '0':'');
    }

    toggleTab(key) {

        let keyToSet = key;
        if(this.state.currentTab === key) {
            keyToSet = false;
        }
        this.setState({
            ...this.state,
            currentTab: keyToSet
        })
    }

    _mapReports(value, key) {
        return (
            <li key={key}>
                <a target="_BLANK" href={value.url}>
                    <div className="list__item list__item--col-2">{value.name}</div>
                    <div className="list__item list__item--col-2 list__item--smaller">{value.repetative}</div>
                    <div className="list__item list__item--col-2 list__item--smaller">{value.date_requested}</div>
                    <div className="list__item list__item--col-2 list__item--smaller">{value.date_ttl}</div>
                    <div className="list__item list__item--col-2 list__item--smaller">{value.next_report}</div>
                </a>
                <div className="list__item list__item--col-2--last"><a href="#generate" onClick={(e) => this._regenerateReport(e, value.id, key)}>{value.is_active === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</a></div>
            </li>
        )
    }
    _regenerateReport(e, id, reportKey) {
        e.preventDefault();
        this.props.setRepetativeActive(this.props.clientPath + '/api/reports/action/setactive', id, this.props.user.user_id);

        // -- find address index for update
        const addressId = this.props.match.params.id;
        const addressIndex = lodash.findIndex(this.props.addresses, function(value) { return value.dp_address_id === addressId; });

        // -- set report active or not
        this.props.addresses[addressIndex].reports[reportKey].is_active = (this.props.addresses[addressIndex].reports[reportKey].is_active === '1' ? '0' : '1')
        this.setState({address: this.props.addresses[addressIndex]})
    }

    toggleReportCollapse() {
        var section = document.querySelector('.hidden__list--reports');
        var isCollapsed = this.state.reportsCollapsed;

        if(isCollapsed) {
            window.Avantage.Expand(section)
            this.setState({
                reportsCollapsed: false
            })
        } else {
            window.Avantage.Collapse(section)
            this.setState({
                reportsCollapsed: true
            })

        }
    }
    render () {
         if(!this.state.address.products || this.state.address.products.length === 0) {
            return null;
        }

        const arraySize = this.state.address.reports.length;
        const start = 0;
        const end = 10;
        return (
            <div className="card" >

                <div className="card__header">
                    <h1>Verzamelberichten</h1>

                    <NavLink to={"/reports" } className="top__right__link">
                            Nieuw verzamelbericht opvragen
                    </NavLink>
                    {this.state.address.reports ? this.state.address.reports.length > end ? <span style={{clear: 'both'}} className="show__more show__more--collapsed" onClick={this.toggleReportCollapse}>{this.state.reportsCollapsed ? <span>Toon meer <i className="fa fa-chevron-down"></i></span> : <span>Toon minder <i className="fa fa-chevron-up"></i></span>}</span> : null : null}

                </div>

                <div className="card__body">
                    <div className="card__content">
                        <ul className="styled__list__headers">
                            <li className="list__header list__header--col-2">Soort verzamelbericht</li>
                            <li className="list__header list__header--col-2">Herhaling</li>
                            <li className="list__header list__header--col-2">Datum <span class="visible__lg">aangevraagd</span></li>
                            <li className="list__header list__header--col-2">Houdbaarheid</li>
                            <li className="list__header list__header--col-2">Nieuw verzamelbericht</li>
                            <li className="list__header list__header--col-2--last">Actief?</li>
                        </ul>
                        <ul className="styled__list">
                            {this.state.address.reports ? this.state.address.reports.slice(start, end).map((value, key) => this._mapReports(value, key)) : ''}
                            <span className={"collapsible hidden__list--reports"}>
                                {this.state.address.reports ? this.state.address.reports.slice(end, arraySize).map((value, key) => this._mapReports(value, key)) : ''}
                            </span>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
  return {
    addresses: state.AddressReducer.addresses,
    searchData: state.SearchDataReducer,
    user: state.UserReducer,
    clientPath: state.ClientPathReducer.clientPath
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        setRepetativeActive: (url, report_id, user_id) => dispatch(setRepetativeActive(url, report_id, user_id))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddressesReports));



// WEBPACK FOOTER //
// ./src/components/Addresses/AddressesReports/index.js